export default function () {
    return {
        data:{},
        dataDefault:{
            id: '',
            descricao: '',
            nome: '',
            host: '',
            host_auxiliar: '',
            usuario: '',
            senha: '',
            tipo: '',
            ordem: '',
            nivel: '',
            status: 'A',
        },
        disableForm: false,
        bancos:[],
        pagination:{}
    }
  }
  